export default "__VITE_PUBLIC_ASSET__d23a85e1__"